import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import moment from 'moment';
import {fetchAssetMonthlyStatistics, fetchAssetSitePageStatistics} from '../../../api/statisticsApi';


const useAssetStatistics = (selectedSite, startDate, endDate) => {
    const [statisticsData, setStatisticsData] = useState(null);
    const [monthlyLoading, setMonthlyLoading] = useState(false);

    const [sitePageData, setSitePageData] = useState(null);
    const [sitePageLoading, setSitePageLoading] = useState(false);

    useEffect(() => {
        let filter = `eventTime >= '${startDate.format("YYYY-MM-DD")}' AND eventTime < '${moment(endDate).add(1, "day").format("YYYY-MM-DD")}' AND userId Like '%@shell.com'`;
        if (selectedSite.length > 0) {
            filter = `site IN (${selectedSite.map(site => `'${site.value.replace(/'/g, "''")}'`).join(', ')}) AND eventTime >= '${startDate.format("YYYY-MM-DD")}' AND eventTime < '${moment(endDate).add(1, "day").format("YYYY-MM-DD")}' AND userId Like '%@shell.com'`;
        }
        const fetchMonthlyStatistics = async () => {
            setMonthlyLoading(true);
            try {
                const statisticData = await fetchAssetMonthlyStatistics(filter);
                setStatisticsData(statisticData);
            } catch (err) {
                console.error(err);
                toast.error("Cannot get Asset Monthly Usage");
            } finally {
                setMonthlyLoading(false);
            }
        };
        const fetchSitePageStatistics = async () => {
            setSitePageLoading(true);
            try {
                const statisticData = await fetchAssetSitePageStatistics(filter);
                setSitePageData(statisticData);
            } catch (err) {
                console.error(err);
                toast.error("Cannot get Asset Monthly Usage");
            } finally {
                setSitePageLoading(false);
            }
        };

        fetchMonthlyStatistics();
        fetchSitePageStatistics();
    }, [selectedSite, startDate, endDate]);

    return { statisticsData, monthlyLoading, sitePageData, sitePageLoading };
};

export default useAssetStatistics;